import React from 'react';
import SvgIcon from './SvgIcon';

const CaretLeft = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M18.743.5L6.168 11.626a.5.5 0 000 .748L18.743 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CaretLeft.displayName = 'CaretLeftIcon';

export default CaretLeft;
